import { render } from "./App.vue?vue&type=template&id=6a4a360c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6a4a360c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__